import { render } from "./PickGpsDeviceFromShip.vue?vue&type=template&id=5eee5d71&scoped=true"
import script from "./PickGpsDeviceFromShip.vue?vue&type=script&lang=js"
export * from "./PickGpsDeviceFromShip.vue?vue&type=script&lang=js"

import "./PickGpsDeviceFromShip.vue?vue&type=style&index=0&id=5eee5d71&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eee5d71"]])

export default __exports__